<template>
  <!--用户权限 -->
  <div class="userPermission">
    <div class="userPermission_box">
      <el-card>
        <el-button @click="addUser" type="primary">添加角色</el-button>
      </el-card>
      <el-card>
        <el-table
          :data="permissionList"
          border
          ref="multipleTable"
          style="width: 100%; flex: auto"
          tooltip-effect="light"
        >
          <el-table-column type="index" width="80px" label="序号" align="center"></el-table-column>
          <el-table-column label="角色的名字" prop="roleName" width="200px" align="center"></el-table-column>
          <el-table-column label="用户" prop="nickname" align="center">
            <template slot-scope="{row}">
              <div v-for="(item,index) in row.users" :key="index">
                <span class="usered">{{item.nickname}}</span>
                <el-divider direction="vertical"></el-divider>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="菜单&权限" prop="menuName" align="center" width="300px">
            <template slot-scope="{row}">
              <p v-for="(item,index) in row.menus" :key="index">
                {{item.menuName}}
                <span v-for="(i,ind) in item.permissions" :key="ind">
                  <el-tag>{{i.permissionName}}</el-tag>
                </span>
              </p>
            </template>
          </el-table-column>

          <el-table-column
            align="center"
            class-name="small-padding fixed-width"
            label="操作"
            width="200px"
            fixed="right"
          >
            <template slot-scope="{$index}">
              <el-button type="primary" @click="showUpdate($index)">修改</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </div>
    <!-- 添加用户弹框 -->
    <a-modal
      :title="textMap[dialogStatus]"
      :visible="userOpen"
      ok-text="确认"
      cancel-text="取消"
      :footer="null"
      @cancel="handleCancel"
    >
      <el-form
        :model="tempRole"
        label-position="right"
        label-width="200px"
        ref="ruleForm"
        style="width: 90%;margin:20px auto; "
      >
        <el-row>
          <el-form-item label="角色名称" prop="roleName">
            <el-input placeholder="请输入内容" v-model="tempRole.roleName" clearable />
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="菜单&&权限" prop="permissionList">
              <div v-for=" (menu,_index) in allPermission" :key="menu.menuName" class="menus_check">
                <span style="width: 100px;display: inline-block;">
                  <el-button
                    :type="isMenuNone(_index)?'':(isMenuAll(_index)?'success':'primary')"
                    size="mini"
                    style="width:100px;"
                    @click="checkAll(_index)"
                  >{{menu.menuName}}</el-button>
                </span>
                <div style="width:20px;">
                  <i
                    :class="perIndex == _index && perOpen ? 'el-icon-remove-outline'  :  'el-icon-circle-plus-outline'"
                    style="font-size:15px;margin:0 auto;margin-left:35%;"
                    @click="getperOpen(_index)"
                  ></i>
                </div>

                <div
                  style="width:90%;display: inline-block;marginLeft:40px"
                  v-if="perIndex == _index ? perOpen : ''"
                >
                  <el-timeline :reverse="reverse">
                      <!-- :timestamp="perm.id" -->
                    <el-timeline-item
                        v-for="perm in menu.permissions"
                     :key="perm.id"
                    
                    >
                      <el-checkbox-group v-model="tempRole.permissions">
                        <el-checkbox
                         :key="perm.id"
                         :label="perm.id"
                          @change="checkRequired(perm,_index)"
                         
                        >
                          <span
                            :class="{requiredPerm:perm.requiredPerm===1}"
                            style="width: 100%;"
                          >{{perm.permissionName}}</span>
                        </el-checkbox>
                      </el-checkbox-group>
                    </el-timeline-item>
                  </el-timeline>
                  <!-- <el-checkbox-group v-model="tempRole.permissions">
                    <el-checkbox
                      v-for="perm in menu.permissions"
                      :label="perm.id"
                      @change="checkRequired(perm,_index)"
                      :key="perm.id"
                    >
                      <span
                        :class="{requiredPerm:perm.requiredPerm===1}"
                        style="width: 100%;"
                      >{{perm.permissionName}}</span>
                    </el-checkbox>
                  </el-checkbox-group>-->
                </div>
              </div>
              <div style="width:400px;height:50px;line-height:50px">
                <p style="color:red;width:100%;letter-spacing: 5px;">说明:红色权限为对应菜单内的必选权限</p>
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-form-item>
            <el-button @click="userOpen = false">取 消</el-button>
            <el-button v-if="dialogStatus=='create'" type="success" @click="createRole">创 建</el-button>
            <el-button type="primary" v-else @click="updateRole">修 改</el-button>
          </el-form-item>
        </el-row>
      </el-form>
    </a-modal>
  </div>
</template>
<script>
export default {
  data() {
    return {
      reverse: false,
      perOpen: false, //菜单显示
      removeOpen: true, //加
      removeOpens: false, //减
      perIndex: null, //菜单显示下标
      permissionList: [],
      userOpen: false, //添加弹框

      allPermission: [], //所有的权限
      //   添加权限选择
      tempRole: {
        roleName: "",
        roleId: "",
        permissions: []
      },
      dialogStatus: "create",
      textMap: {
        update: "编辑",
        create: "新建角色"
      }
    };
  },
  methods: {
    getperOpen(index) {
      this.$nextTick(() => {
        this.perIndex = index;

        if (this.perOpen == true) {
          this.perOpen = false;
        } else {
          this.perOpen = true;
        }

        this.$store.commit("getOpen", this.perOpen);
      });
    },
    // getperClock(index) {
    //   this.perIndex = index;
    //   this.perOpen = false;
    //   if (this.perOpen == false) {
    //     this.removeOpen = true;//加
    //     this.removeOpens = false;//减
    //   }
    // },
    //角色的列表
    getPermission() {
      this.getAxios("/role/list", {}).then(res => {
        if (res.success == true) {
          this.permissionList = res.content;
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push('/')
        }else if(res.success==false){
          this.$message.error(res.message);
        }
      });
    },

    // 添加角色：
    addUser() {
      this.tempRole.roleName = "";
      this.tempRole.roleId = "";
      this.tempRole.permissions = [];
      this.userOpen = true;
      this.dialogStatus = "create";
    },
    //查询所有权限
    getAllPermisson() {
      this.getAxios("/permission/list", {}).then(res => {
        if (res.success == true) {
          this.allPermission = res.content;
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push('/')
        }else if(res.success==false){
          this.$message.error(res.message);
        }
      });
    },
    //判断本级菜单内的权限是否一个都没选
    isMenuNone(_index) {
      let menu = this.allPermission[_index].permissions;
      let result = true;
      for (let j = 0; j < menu.length; j++) {
        if (this.tempRole.permissions.indexOf(menu[j].id) > -1) {
          result = false;
          break;
        }
      }

      return result;
    },
    //判断本级菜单内的权限是否全选了
    isMenuAll(_index) {
      let menu = this.allPermission[_index].permissions;
      let result = true;
      for (let j = 0; j < menu.length; j++) {
        if (this.tempRole.permissions.indexOf(menu[j].id) < 0) {
          result = false;
          break;
        }
      }

      return result;
    },
    checkAll(_index) {
      //点击菜单   相当于全选按钮
      let v = this;
      if (v.isMenuAll(_index)) {
        //如果已经全选了,则全部取消
        v.noPerm(_index);
      } else {
        //如果尚未全选,则全选
        v.allPerm(_index);
      }
    },

    allPerm(_index) {
      //全部选中
      let menu = this.allPermission[_index].permissions;
      for (let j = 0; j < menu.length; j++) {
        this.addUnique(menu[j].id, this.tempRole.permissions);
      }
    },
    noPerm(_index) {
      //全部取消选中
      let menu = this.allPermission[_index].permissions;
      for (let j = 0; j < menu.length; j++) {
        let idIndex = this.tempRole.permissions.indexOf(menu[j].id);

        if (idIndex > -1) {
          this.tempRole.permissions.splice(idIndex, 1);
        }
      }
    },
    addUnique(val, arr) {
      //数组内防重复地添加元素
      let _index = arr.indexOf(val);
      if (_index < 0) {
        arr.push(val);
      }
    },
    checkRequired(_perm, _index) {
      //本方法会在勾选状态改变之后触发
      let permId = _perm.id;

      if (this.tempRole.permissions.indexOf(permId) > -1) {
        //选中事件
        //如果之前未勾选本权限,现在勾选完之后,tempRole里就会包含本id
        //那么就要将必选的权限勾上
        this.makeReuqiredPermissionChecked(_index);
      } else {
        //取消选中事件
        if (_perm.requiredPerm === 1) {
          //如果是必勾权限,就把本菜单的权限全部移出
          //(其实也可以提示用户本权限是菜单里的必选,请先取消勾选另外几个权限,交互太麻烦,此处就直接全部取消选中了)
          this.noPerm(_index);
        }
      }
    },

    makeReuqiredPermissionChecked(_index) {
      //将本菜单必选的权限勾上
      let menu = this.allPermission[_index].permissions;
      for (let j = 0; j < menu.length; j++) {
        let perm = menu[j];
        if (perm.requiredPerm === 1) {
          //找到本菜单的必选权限,将其勾上
          this.addUnique(perm.id, this.tempRole.permissions);
        }
      }
    },
    //创建权限：
    createRole() {
      if (!this.checkRoleNameUnique()) {
        return;
      }
      if (!this.checkPermissionNum()) {
        return;
      }
      this.postAxios("/role/create", {
        roleId: this.tempRole.roleId,
        roleName: this.tempRole.roleName,
        permissionList: this.tempRole.permissions
      }).then(res => {
        if (res.success == true) {
          this.$message.success("添加成功！");
          this.userOpen = false;
          this.getPermission();
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push('/')
        }else if(res.success==false){
          this.$message.error(res.message);
        }
      });
    },
    //取消弹框
    handleCancel() {
      this.userOpen = false;
    },
    // 修改
    showUpdate($index) {
      let role = this.permissionList[$index];
      this.tempRole.roleName = role.roleName;
      this.tempRole.roleId = role.roleId;
      this.tempRole.permissions = [];
      for (let i = 0; i < role.menus.length; i++) {
        let perm = role.menus[i].permissions;
        for (let j = 0; j < perm.length; j++) {
          this.tempRole.permissions.push(perm[j].permissionId);
        }
      }
      this.dialogStatus = "update";
      this.userOpen = true;
    },
    // 确定修改：
    updateRole() {
      if (!this.checkRoleNameUnique(this.tempRole.roleId)) {
        return; //不执行
      }
      if (!this.checkPermissionNum()) {
        return; //不执行
      }

      this.postAxios("/role/update", {
        roleId: this.tempRole.roleId,
        roleName: this.tempRole.roleName,
        permissionList: this.tempRole.permissions
      }).then(res => {
        if (res.success == true) {
          this.getPermission();
          this.userOpen = false;
          this.$message.success("修改成功");
        } else if (res.success == false) {
          this.$message.error(res.message);
        } else if (!res.success && res.statusCode == "401") {
         this.$message.error(res.message);
         this.$router.push('/')
        }
      });
    },
    checkPermissionNum() {
      //校验至少有一种权限
      if (this.tempRole.permissions.length === 0) {
        this.$message.error("请至少选择一种权限");
        return false;
      }
      return true;
    },
    //校验名称重复
    checkRoleNameUnique(roleId) {
      console.log(roleId, this.permissionList);
      let roleName = this.tempRole.roleName;
      if (!roleName) {
        this.$message.error("请填写角色名称");
        return false;
      }
      let roles = this.permissionList;
      let result = true;
      for (let j = 0; j < roles.length; j++) {
        if (
          roles[j].roleName === roleName &&
          (!roleId || roles[j].roleId !== roleId)
        ) {
          this.$message.error("角色名称已存在");
          result = false;
          break;
        }
      }

      return result;
    }
  },
  created() {
    console.log(this.perIndex, "perIndex");
    this.getPermission(); //获取角色列表
    this.getAllPermisson(); //获取所有的权限
  }
};
</script>
<style scoped lang="less">
.userPermission {
  width: 100%;
  height: 100%;
  .userPermission_box {
    width: 95%;
    height: 100%;
    margin: 0 auto;
    .el-card {
      width: 100%;
      height: auto;
      margin-top: 15px;
      .usered {
        width: 100%;
        height: 30px;
        line-height: 30px;
        text-align: center;
      }
    }
  }
}

.requiredPerm {
  color: #ff0e13;
}
.menus_check {
  display: flex;
}
/deep/ .ant-modal {
  width: 700px !important;
}
/deep/ .el-button--primary {
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
  width: 100px;
}
/deep/ .el-checkbox {
  width: 100%;
  margin-top: 1px;
}
/deep/ .el-icon-remove-outline {
  margin-left: 27px !important;
}
/deep/ .el-checkbox-group{
  position: relative;
  top: -13px;
}
/deep/ .el-timeline-item {
    position: relative;
    padding-bottom: 2px;
}
.el-timeline{
  margin-top: 14px;
}
</style>